export type LoginSessionStatus = "authenticated" | "anonymous";

/**
 * Probes GET /session before showing / submitting the login form.
 *
 * CSRF is enforced whenever the httpOnly `tid` cookie is present. A stale
 * session cookie would make POST /auth/login fail with csrf_token_invalid
 * because the HTML form cannot send X-CSRF-Token.
 *
 * GET /session clears a leftover `tid` when the session is already invalid.
 * If the probe itself fails, `clearStaleSession` (GET /auth/logout) is the
 * fallback — JavaScript cannot delete the httpOnly cookie.
 */
export async function prepareLoginSession(deps: {
    fetchSession: () => Promise<{ session?: unknown }>;
    clearStaleSession: () => Promise<unknown>;
}): Promise<LoginSessionStatus> {
    try {
        const result = await deps.fetchSession();
        return result?.session ? "authenticated" : "anonymous";
    } catch {
        await deps.clearStaleSession().catch(() => undefined);
        return "anonymous";
    }
}
